"use client";

import type { AboutData } from "@/services/public.service";

function Icon({ name, className = "" }: { name: string; className?: string }) {
  return <span className={`material-symbols-outlined ${className}`}>{name}</span>;
}

// Map the dashboard's lucide icon names → Material Symbols used on this page.
const ICON_MAP: Record<string, string> = {
  Landmark: "account_balance", ShieldCheck: "verified_user", Shield: "shield",
  Sparkles: "auto_awesome", HeartHandshake: "handshake", Heart: "favorite",
  Leaf: "eco", Rocket: "rocket_launch", Star: "star", Award: "workspace_premium",
  Users: "groups", Home: "home", Building: "apartment", Globe: "public",
  Compass: "explore", Lightbulb: "lightbulb", ThumbsUp: "thumb_up", Gem: "diamond",
  Clock: "schedule", MapPin: "location_on", Handshake: "handshake",
};
const msIcon = (lucide?: string) => ICON_MAP[lucide || ""] || "check_circle";

export default function AboutValues({ about, isAr }: { about: AboutData; isAr: boolean }) {
  const t = (a: string, e: string) => (isAr ? a : e);
  const values = about.values || [];
  if (values.length === 0) return null;

  return (
    <section className="container mx-auto px-6 py-16 md:py-20">
      <div className="text-center mb-12">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-ink-900">
          {t("قيمنا", "Our values")}
        </h2>
        <p className="text-ink-500 mt-3 max-w-xl mx-auto">
          {t("المبادئ التي توجّه كل ما نقوم به في منازل الدرعية.", "The principles that guide everything we do at Diriyah Homes.")}
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {values.map((v, i) => (
          <div key={i} className="rounded-2xl border border-clay-100 bg-surface p-7 hover:shadow-md hover:border-clay-300 transition-all">
            <div className="w-14 h-14 rounded-2xl bg-clay-600 text-white flex items-center justify-center mb-5">
              <Icon name={msIcon(v.icon)} className="text-3xl fill" />
            </div>
            <h3 className="font-bold text-lg text-ink-900 mb-2">{isAr ? v.title.ar : v.title.en}</h3>
            <p className="text-sm text-ink-500 leading-relaxed">{isAr ? v.description.ar : v.description.en}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
